import React, { useEffect, useState } from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { Badge } from "../components/ui/badge";
import { planningChecklist } from "../mock";
import { Checkbox } from "../components/ui/checkbox";

export default function PlanningGuide() {
  const [checked, setChecked] = useState(() => {
    try { return JSON.parse(localStorage.getItem("planning_checklist") || "{}"); } catch { return {}; }
  });

  useEffect(() => { localStorage.setItem("planning_checklist", JSON.stringify(checked)); }, [checked]);

  return (
    <section id="planning" className="max-w-6xl mx-auto px-6 py-16">
      <div className="mb-6">
        <Badge className="bg-[hsl(22,100%,50%)]/10 text-[hsl(22,100%,40%)]">Planning & Approvals</Badge>
        <h2 className="text-2xl md:text-3xl font-bold tracking-tight mt-3">Planning permission made simple</h2>
        <p className="text-muted-foreground mt-2 max-w-prose">Many extensions fall under Permitted Development, but constraints like conservation areas and previous works can change the rules. We’ll advise the best route.</p>
      </div>

      <Accordion type="single" collapsible className="space-y-3">
        <AccordionItem value="pd" className="border border-white/30 bg-white/60 backdrop-blur-md rounded-lg px-4">
          <AccordionTrigger>Permitted Development vs Full Planning</AccordionTrigger>
          <AccordionContent className="text-muted-foreground">We review size, height, materials and proximity limits to confirm if your project fits Permitted Development or requires a full planning application or LDC.</AccordionContent>
        </AccordionItem>
        <AccordionItem value="party" className="border border-white/30 bg-white/60 backdrop-blur-md rounded-lg px-4">
          <AccordionTrigger>Party Wall & Neighbours</AccordionTrigger>
          <AccordionContent className="text-muted-foreground">If your works affect a shared wall or boundary, notices and agreements may be required. We help you navigate the process.</AccordionContent>
        </AccordionItem>
        <AccordionItem value="bc" className="border border-white/30 bg-white/60 backdrop-blur-md rounded-lg px-4">
          <AccordionTrigger>Building Control</AccordionTrigger>
          <AccordionContent className="text-muted-foreground">We set the route (Full Plans or Building Notice), coordinate inspections and ensure compliance at each stage.</AccordionContent>
        </AccordionItem>
      </Accordion>

      <div className="mt-8">
        <h3 className="font-semibold">Your planning checklist</h3>
        <div className="grid sm:grid-cols-2 gap-3 mt-3">
          {planningChecklist.map((item) => (
            <label key={item.id} className="flex items-center gap-2 rounded-lg border border-white/30 bg-white/60 backdrop-blur-md p-3 text-sm">
              <Checkbox checked={!!checked[item.id]} onCheckedChange={(v) => setChecked((s) => ({ ...s, [item.id]: !!v }))} />
              {item.label}
            </label>
          ))}
        </div>
      </div>
    </section>
  );
}